<block-ui></block-ui>
  <div *ngIf="ShowPageContent" class="container-fluid">
    <div class="card card-custom-h">
      <div class="card-header border-0 pt-5">
        <div class="card-title align-items-start flex-column" *ngIf="IsFilterLoaded">
          <form [formGroup]="EmailHeaderAndFooterTemplateForm">
            <BBSF-TextBox [options]="searchTextBox" [group]="EmailHeaderAndFooterTemplateForm"></BBSF-TextBox>

          </form>
        </div>
        <div class="card-toolbar">
          <!-- begin::Menu -->
          <a id="btnSetPass" *ngIf="!ProductionMode" class="btn btn-sm btn-light-primary me-3" href="javascript:;"(click)="showGenerateCodeModal(GenerateCodeModal)">
            <i class="fa fa-key"></i>{{utilityService.getResourceValue("GenerateCode")}}
          </a>
          <button type="button" title="Add" class="btn btn-primary btn-sm "
                  [routerLink]="['/Admin/Notifications/Add']" routerLinkActive="router-link-active">
            <i class=" fa fa-plus"></i>{{utilityService.getResourceValue("Add")}}
          </button>

          <!-- end::Menu -->
        </div>
      </div>
      <!-- end::Header -->
      <!-- begin::Body -->
      <div class="card-body py-3">
        <div class="table-responsive">
          <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
            <thead>
              <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                <th class="min-w-150">{{utilityService.getResourceValue("NameInEnglish")}}</th>
                <th class="min-w-150">{{utilityService.getResourceValue("NameInArabic")}}</th>
                <th class="min-w-50">{{utilityService.getResourceValue("Action")}}</th>
              </tr>
            </thead>
            <tbody id="listingContainer" class="fw-bold text-gray-600 border-0">
              <tr *ngFor="let template of EmailHeaderAndFooterTemplatePagingResult">

                <td class="text-dark">
                  {{template.name.english}}
                </td>
                <td>{{template.name.arabic}}</td>
                <td>
                  <div>
                    <button mat-button [matMenuTriggerFor]="menu" class="btn btn-sm btn-icon btn-light btn-active-light-primary">
                      <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                    </button>
                    <mat-menu #menu="matMenu">
                      <button type="button" ngbDropdownItem class="drop-item px-3"
                              [routerLink]="['/Admin/Notifications/Edit',template.id]"
                              routerLinkActive="router-link-active">
                        <span class="drop-link">{{utilityService.getResourceValue("Edit")}}</span>
                      </button>
                      <button type="button" ngbDropdownItem class="drop-item px-3" id="btnResetPass"
                              (click)="showDeleteEmailHeaderAndFooterTemplateModal(template, deleteEmailHeaderAndFooterTemplateModal)">
                        <span class="drop-link">{{utilityService.getResourceValue("Delete")}}</span>
                      </button>
                    </mat-menu>
                  </div>
                </td>
              </tr>
              <tr *ngIf="EmailHeaderAndFooterTemplatePagingResult.length == 0">
                <td colspan="3">
                  <lib-empty-data></lib-empty-data>
                </td>
              </tr>
            </tbody>
          </table>
          <!--end::Permission list-->
        </div>
      </div>
      <div class="card-footer">
        <BBSF-Paging (Items)="setEmailHeaderAndFooterTemplateResult($event)" *ngIf="IsFilterLoaded"
                     [options]="EmailHeaderAndFooterTemplatePaging" [group]="EmailHeaderAndFooterTemplateForm"
                     #EmailHeaderAndFooterTemplatePagingViewElement>
        </BBSF-Paging>
      </div>
    </div>
  </div>

  <!--delete Modal-->
  <ng-template #deleteEmailHeaderAndFooterTemplateModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("Delete")}}</h1>
      </div>
      <div class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-10 p-6">
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <span [inlineSVG]="'./src/assets/images/gen044.svg'"></span>
        </span>

        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <div class="fs-6 text-gray-700">
              {{utilityService.getResourceValue("Delete_Question")}}
            </div>
          </div>
        </div>
      </div>
      <div class="text-center pt-7">
        <button #CloseDeleteEmailHeaderAndFooterTemplateModal  id="CloseDeleteEmailHeaderAndFooterTemplateModal" type="button"
                class="btn btn-light btn-sm me-3 " data-dismiss="modal" (click)="modal.dismiss()">
          {{utilityService.getResourceValue("CancelLabel")}}
        </button>
        <button type="button" (click)="deleteEmailHeaderAndFooterTemplate()"
                class="btn btn-light-danger btn-sm ">
          {{utilityService.getResourceValue("Delete")}}
        </button>
      </div>
    </div>
  </ng-template>

  <!-- GenerateCode Modal -->
  <ng-template #GenerateCodeModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("GenerateCode")}}</h1>
      </div>
      <form [formGroup]="GenerateCodeForm">

        <div class="Row">
          <BBSF-TextArea [options]="GenerateCodeTextArea" [group]="GenerateCodeForm"
                         #GenerateCodeInput>
          </BBSF-TextArea>
        </div>

        <div class="text-center pt-7">
          <button #CloseGenerateCodeModal id="CloseGenerateCodeModal" type="button" class="btn btn-light me-3 btn-sm"
                  (click)="modal.dismiss()">
            {{utilityService.getResourceValue("CancelLabel")}}
          </button>
          <button type="button" class="btn btn-primary btn-sm" (click)="copyInputMessage()">
            {{utilityService.getResourceValue("CopyToClipboard")}}
          </button>
        </div>
      </form>
    </div>
  </ng-template>
